// extracted by mini-css-extract-plugin
export var tosLink = "_au-0";